/**
 * Formats a user's full name including prefix and suffix
 * @param {Object} user - User object with prefix, firstName, lastName, suffix
 * @returns {string} Formatted name (e.g., "Dr. John Smith, DVM")
 */
export const formatFullName = (user) => {
  if (!user) return '';
  
  const parts = [];
  
  if (user.prefix) {
    parts.push(user.prefix.trim());
  }
  
  if (user.firstName) {
    parts.push(user.firstName.trim());
  }
  
  if (user.lastName) {
    parts.push(user.lastName.trim());
  }
  
  if (user.suffix) {
    parts.push(user.suffix.trim());
  }
  
  return parts.join(' ') || '';
};

/**
 * Formats a user's name for display (without prefix/suffix)
 * @param {Object} user - User object with firstName, lastName
 * @returns {string} Formatted name (e.g., "John Smith")
 */
export const formatName = (user) => {
  if (!user) return '';
  
  const parts = [];
  if (user.firstName) parts.push(user.firstName.trim());
  if (user.lastName) parts.push(user.lastName.trim());
  
  return parts.join(' ') || '';
};

/**
 * Gets initials from a user's name for avatars
 * @param {Object} user - User object with firstName, lastName
 * @returns {string} Initials (e.g., "JS")
 */
export const getInitials = (user) => {
  if (!user) return '';
  
  const firstName = user.firstName || '';
  const lastName = user.lastName || '';
  
  if (firstName && lastName) {
    return `${firstName[0]}${lastName[0]}`.toUpperCase();
  } else if (firstName) {
    return firstName[0].toUpperCase();
  } else if (lastName) {
    return lastName[0].toUpperCase();
  }
  
  return '';
};

